import React from "react";

export default function Help() {
    return <div className="container">
        <div>
            <div>
                <h2>Help</h2>
                <p>
                    <strong>Telephone:</strong> +44 (0) 1792 455 175 <br />
                    <strong>Email:</strong> <a href="mailto:support@zetaremote.com">support@zetaremote.com</a>
                </p>
                <address>
          GLT Exports Ltd<br />
          Detection House<br />
          72-78 Morfa Road<br />
          Swansea<br />
          SA1 2EN<br />
          United Kingdom
                </address>
            </div>
        </div>
    </div>
}